import { useWelfarePopup } from '../../features/settings/hooks/useWelfarePopup';
import { WelfarePopupSection } from './WelfarePopupSection';
import { useHomeBanners, useHomeAnnouncements, useHomePopup, useMarketConfigs } from '../../features/settings';
import { HomeBannerSection } from './HomeBannerSection';
import { HomeAnnouncementSection } from './HomeAnnouncementSection';
import { HomePopupSection } from './HomePopupSection';

export function HomeContentPage() {
  const banners = useHomeBanners();
  const announcements = useHomeAnnouncements();
  const popup = useHomePopup();
  const welfarePopup = useWelfarePopup();
  const markets = useMarketConfigs();

  const loading = banners.loading || announcements.loading || popup.loading || markets.loading;
  const error = banners.error || announcements.error || popup.error || markets.error;

  if (loading) {
    return (
      <div className="flex items-center justify-center py-20">
        <div className="h-6 w-6 border-2 border-gray-300 border-t-primary rounded-full animate-spin" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="py-20 text-center">
        <p className="text-sm text-red-500 mb-3">{error}</p>
        <button
          onClick={() => { banners.reload(); announcements.reload(); popup.reload(); markets.reload(); }}
          className="text-sm text-primary hover:underline"
        >
          重试
        </button>
      </div>
    );
  }

  return (
    <div className="max-w-4xl space-y-8">
      <p className="text-sm text-gray-500">
        管理首页轮播 Banner、走马灯公告、首页弹窗和福利活动弹窗内容，修改后即时生效。
      </p>

      <HomeBannerSection
        items={banners.items}
        updatedAt={banners.updatedAt}
        saving={banners.saving}
        markets={markets.items}
        onCreate={banners.create}
        onUpdate={banners.update}
        onRemove={banners.remove}
      />

      <hr className="border-gray-200" />

      <HomeAnnouncementSection
        items={announcements.items}
        updatedAt={announcements.updatedAt}
        saving={announcements.saving}
        markets={markets.items}
        onCreate={announcements.create}
        onUpdate={announcements.update}
        onRemove={announcements.remove}
      />

      <hr className="border-gray-200" />

      <section>
        {welfarePopup.loading ? <p className="text-sm text-gray-500">福利活动弹窗加载中…</p> : welfarePopup.error ? <div role="alert" className="text-sm text-red-600">{welfarePopup.error} <button type="button" onClick={welfarePopup.reload}>重试</button></div> : <WelfarePopupSection data={welfarePopup.data} saving={welfarePopup.saving} markets={markets.items} onUpdate={welfarePopup.update} />}
      </section>
      <hr className="border-gray-200" />
      <HomePopupSection
        data={popup.data}
        saving={popup.saving}
        markets={markets.items}
        onUpdate={popup.update}
      />
    </div>
  );
}
